/**
 * TekMegha platform superadmin (not store role `super_admin`).
 * Used for cross-store enquiries + food default catalog admin.
 */
export const TEKMEGHA_SUPER_ADMIN_USER_ID = 'b3bfe84b-4811-4dad-bc11-90590b452abd';

/** @deprecated Use TEKMEGHA_SUPER_ADMIN_USER_ID */
export const SUPER_ADMIN_ENQUIRIES_USER_ID = TEKMEGHA_SUPER_ADMIN_USER_ID;

export function isTekmeghaSuperAdmin(userId: string | null | undefined): boolean {
  return !!userId && userId.trim().toLowerCase() === TEKMEGHA_SUPER_ADMIN_USER_ID.toLowerCase();
}

/** @deprecated Use isTekmeghaSuperAdmin */
export function isSuperAdminEnquiriesUser(userId: string | null | undefined): boolean {
  return isTekmeghaSuperAdmin(userId);
}
